const settings = {
    colors: {
        lightblue: '#00A9E2',
        brown: 'rgb(104, 79, 53)',
    },
    swiper: {
        baseSettings: {
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 40,
            direction: 'horizontal',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 10,
                },
            },
        },
    },
    configurator: {
        pensWithoutCustomCustomizationOption: ['ray-fh', 'ray-pr', 'klick-fix', 'ceod-classic'],
        pensWithSingleColorAreas: {
            'slider-basic-xb': ['S1', 'T4']
        }
    }
};

export default settings;
